import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GeneralService } from './core/services/general.service';
import { LoginService } from './core/services/login.service';
import { AuthResponseDTO } from './core/models/AuthResponseDTO';
import { LoaderService } from './core/interceptors/loader.service';
import { UrlNormalizerService } from './core/services/url-normalizer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isAuth: boolean = false;
  constructor(
    private router: Router,
    public generalService: GeneralService,
    private _loginService: LoginService,
    public loaderService: LoaderService,
    private urlNormalizer: UrlNormalizerService
  ) {
    this.isAuth = location.pathname.includes('auth');
  }

  ngOnInit(): void {
    // Extract URL hash
    const hash = window.location.hash;

    if (hash.startsWith('#/login')) {
      // Remove the '#' and redirect to the proper route
      const newUrl = hash.substring(1); // Removes "#"
      this.router.navigateByUrl(newUrl);
    }

    const pathName = location.pathname;
    const result = this.findPageByPathname(this.adminPages, pathName);

    if (result) {
      result.parent.isOpen = true;
      result.match.isActive = true;
    }
  }

  findPageByPathname(adminPages: any, pathName: string) {
    for (const page of adminPages) {
      if (page.pathname === pathName) {
        return { parent: page, match: page };
      }

      if (page.links && page.links.length > 0) {
        for (const link of page.links) {
          if (link.pathname === pathName) {
            return { parent: page, match: link };
          }
        }
      }
    }

    return null;
  }

  adminPages = [
    {
      title: 'Dashboard',
      id: 0,
      links: [],
      isOpen: false,
      isActive: false,
      pathname: '/papi/dashboard',
      access: ['Developer', 'Sales', 'Tester'],
      linkTo: 'home',
      icon: 'home',
    },
    {
      title: 'Dashsdaboard',
      id: 123,
      links: [],
      isOpen: false,
      isActive: false,
      pathname: '/papi/dashboards',
      access: ['Developer', 'Sales', 'Tester'],
      linkTo: 'home',
      icon: 'home',
    },
    {
      title: 'Activity',
      id: 3,
      links: [
        {
          title: 'Balance',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/balance',
          linkTo: '',
        },
        {
          title: 'Transactions',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/transactions',
          linkTo: '',
        },
      ],
      access: ['Project Lead', 'Developer', 'Sales', 'Tester'],
      linkTo: '',
      pending: false,
      isOpen: false,
      isActive: false,
      icon: 'transactions',
    },
    {
      title: 'Reports',
      id: 4,
      links: [
        {
          title: 'GoAML',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/go-aml',
          linkTo: '',
        },
        {
          title: 'Monitoring',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/outage',
          linkTo: '',
        },
      ],
      access: ['Project Lead', 'Developer', 'Sales', 'Tester'],
      linkTo: '',
      isOpen: false,
      isActive: false,
      icon: 'system',
    },
    {
      title: 'System',
      id: 5,
      links: [
        {
          title: 'Orgniasations',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/organisations',
          linkTo: '',
        },
        {
          title: 'Groups',
          pending: false,
          isOpen: false,
          isActive: false,
          id: 4,
          pathname: '/papi/groups',
          linkTo: '',
        },
      ],
      access: ['Project Lead', 'Developer', 'Sales', 'Tester'],
      linkTo: 'balance',
      isOpen: false,
      isActive: false,
      icon: 'balance',
    },
  ];

  profileItems = [
    {
      label: 'Reporting Settings',
      action: () => {
        location.replace('papi/settings');
      },
      icon: 'system',
    },
    {
      label: "What's new",
      action: () => {
        location.replace('papi/whats-new');
      },
      icon: 'product',
      description: 'Version 1.9.8',
      tooltip: 'This is a sample tooltip',
    },
    {
      label: 'Logout',
      action: () => {
        this._loginService.logout().subscribe(
          (response: any) => {
            let success: AuthResponseDTO = response;
            if (success.responseCode === '200') {
              localStorage.clear();
              localStorage.setItem('reload', 'true');
              location.replace('/auth/login');
            } else {
              localStorage.clear();
              localStorage.setItem('reload', 'true');
              location.replace('/auth/login');
            }
          },
          (error) => {
            location.replace('/auth/login');
          }
        );
      },
      icon: 'logout-new',
    },
  ];

  switchTab(tab: any): void {
    if (tab.pathname) this.router.navigate([tab.pathname]);
  }
}
